// Small icon-only mark for menu rows where a generic Lucide icon
// doesn't carry enough brand identity (e.g. "OFinancial Social" inside
// the Accounts mega menu).
//
// Mimics the Lucide icon API so the component can be passed verbatim
// to the existing menu renderer:
//   <OFinIcon size={18} strokeWidth={1.7} className="text-brand" />
//
// `strokeWidth` is accepted but ignored — the SVG is solid-fill.
//
// Renders an inline SVG (not an <img>) so we can tint the glyph with
// `currentColor`. The source brand mark is light cyan `#aadeeb`, which
// vanishes on the white light-mode menu surface. Inline-tinted, it
// follows the `text-brand` Tailwind class on the surrounding span.
export default function OFinIcon({ size = 18, className = "", strokeWidth, style, ...rest }) {
  void strokeWidth;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 236.58 236.58"
      role="img"
      aria-label="OFinancial"
      className={className}
      style={{ display: "inline-block", verticalAlign: "middle", color: "currentColor", ...style }}
      {...rest}
    >
      {/* Outer rounded square · subtle 8 % fill behind the ring so the
          mark feels weighty next to the Lucide line icons it sits
          alongside in the menu. */}
      <rect x="2" y="2" width="232.58" height="232.58" rx="46" ry="46"
            fill="currentColor" fillOpacity="0.10" />
      {/* Ring */}
      <circle cx="118.29" cy="118.29" r="79.5" fill="none" stroke="currentColor" strokeWidth="18" />
      {/* "F" cross-bar */}
      <rect x="99" y="80" width="60" height="14" fill="currentColor" />
      <rect x="99" y="80" width="14" height="78" fill="currentColor" />
      <rect x="99" y="115" width="42" height="13" fill="currentColor" />
    </svg>
  );
}
